import {
  HeadingText,
  ParagraphText,
  Modal,
  ImageMessage,
  StackLayout,
  useMediaQuery,
  queryHelpers,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { getModulePath, LEAGUE_MODULE_NAMES } from '@leagueplatform/core';
import { useNavigate } from 'react-router-dom';
import { PRODUCT_AREA } from '@leagueplatform/analytics';
import { DETAIL } from '@telus-alberta-health-web/shared-module';
import healthRecordsIllustration from 'assets/illustrative-health-records.svg';
import { BaseModalContainer } from 'components/modals/common/base-modal.component';
import { ModalActionButton } from 'components/modals/common/modal-action-button.component';

const SCREEN_NAME = 'Care Services';

export const ChangeAnnouncementModal = () => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(queryHelpers.only('mobile'));

  return (
    <BaseModalContainer
      footer={
        <StackLayout
          orientation={isMobile ? 'vertical' : 'horizontal'}
          spacing="$one"
          horizontalAlignment={isMobile ? 'stretch' : 'end'}
          css={{ marginBlockStart: '$one' }}
        >
          <ModalActionButton
            actionType="cancel"
            buttonText={formatMessage({
              id: 'STR_CHANGE_ANNOUNCEMENT_GO_TO_MY_HEALTH',
            })}
            isMobile={isMobile}
            onClick={() => navigate(getModulePath(LEAGUE_MODULE_NAMES.aboutMe))}
            trackAnalytics={{
              product_area: PRODUCT_AREA.CARE,
              screen_name: SCREEN_NAME,
              detail: DETAIL.CHANGE_ANNOUNCEMENT_GO_TO_MY_HEALTH,
            }}
          />
          <ModalActionButton
            actionType="submit"
            buttonText={formatMessage({ id: 'STR_CHANGE_ANNOUNCEMENT_OKAY' })}
            isMobile={isMobile}
            trackAnalytics={{
              product_area: PRODUCT_AREA.CARE,
              screen_name: SCREEN_NAME,
              detail: DETAIL.CHANGE_ANNOUNCEMENT_OKAY,
            }}
          />
        </StackLayout>
      }
    >
      <ImageMessage
        image={healthRecordsIllustration}
        imageAlt=""
        css={{ flexGrow: 1, textAlign: 'left' }}
      >
        <Modal.Title>
          <HeadingText level="2" size="lg" css={{ marginBlock: '$one' }}>
            {formatMessage({ id: 'STR_CHANGE_ANNOUNCEMENT_TITLE' })}
          </HeadingText>
        </Modal.Title>
        <ParagraphText>
          {formatMessage({ id: 'STR_CHANGE_ANNOUNCEMENT_BODY' })}
        </ParagraphText>
      </ImageMessage>
    </BaseModalContainer>
  );
};
